module.exports = __webpack_public_path__ + "static/media/9_unlocked-new-badge.eb8fd5b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/9_unlocked-new-badge.mp3
// module id = G4J5
// module chunks = 0